import CityPageTemplate from "../city-template/CityPageTemplate";
import { indianapolisConfig } from "./data";

export default function IndianapolisPage() {
  return <CityPageTemplate config={indianapolisConfig} />;
}